import { TinkertoyActionRedirectError } from "./action-errors";

/**
 * Navigate the browser in response to an action JSON redirect hint.
 *
 * Action endpoints return `{ type: "redirect", location, external? }` with
 * HTTP 200 — never HTTP 302 — so `fetch` can parse JSON and the shell decides
 * how to navigate.
 *
 * When `external` is false, throws {@link TinkertoyActionRedirectError} so the
 * caller can SPA-navigate. Otherwise hard-navigates via `window.location.assign`
 * and returns a promise that never settles.
 */
export function applyActionRedirect(
  location: string,
  external?: boolean,
): Promise<never> {
  if (external === false) {
    throw new TinkertoyActionRedirectError(location, { external: false });
  }

  window.location.assign(location);
  return new Promise<never>(() => undefined);
}
